import { o as c, c as e, a as o } from "./core.0767a1be.js";
const s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, t = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M945.067 898.133 755.2 708.267c55.467-64 87.467-149.334 87.467-241.067 0-204.8-168.534-373.333-373.334-373.333S96 264.533 96 469.333s168.533 373.334 373.333 373.334c91.734 0 174.934-34.134 241.067-87.467l189.867 189.867c6.4 6.4 14.933 8.533 23.466 8.533s17.067-2.133 23.467-8.533c8.533-12.8 8.533-34.134-2.133-46.934zM469.333 778.667C298.667 778.667 160 640 160 469.333S298.667 160 469.333 160s309.334 138.667 309.334 309.333S640 778.667 469.333 778.667z"
}, null, -1), n = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M597.333 437.333h-96v-96c0-17.066-14.933-32-32-32s-32 14.934-32 32v96h-96c-17.066 0-32 14.934-32 32s14.934 32 32 32h96v96c0 17.067 14.934 32 32 32s32-14.933 32-32v-96h96c17.067 0 32-14.933 32-32s-14.933-32-32-32z"
}, null, -1), r = [
  t,
  n
];
function l(a, h) {
  return c(), e("svg", s, r);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
//# sourceMappingURL=zoom-in.aba10c2c.js.map
